export const SHOP_URL = 'https://www.nuevonivel.shop'
export const SUPPORT_EMAIL = 'soportenuevonivel@gmail.com'

/** Checkout directo de Shopify (agrega el producto al carrito y va al pago) */
export const CHECKOUT_ESENCIAL = 'https://www.nuevonivel.shop/cart/50278654902512:1'
export const CHECKOUT_PREMIUM = 'https://www.nuevonivel.shop/cart/50278655459568:1'

export const trustItems = [
  'Garantía 7 días',
  'Pago seguro',
  'Mercado Pago',
  '100% PDF',
  'Acceso en 5 min',
  '3 Tomos + 6 Bonos',
]

export const heroStats = [
  { value: '+800', label: 'Kinesiólogos' },
  { value: '3', label: 'Tomos' },
  { value: '6', label: 'Bonos' },
  { value: '4.9★', label: 'Valoración' },
]

export const painPoints = [
  'Llegás cansado/a al consultorio y no sabés qué ejercicio indicar para cada paciente',
  'Armás la sesión sobre la marcha y perdés tiempo valioso que podrías cobrar',
  'El paciente no hace los ejercicios en casa porque no entendió cómo',
  'Gastás horas buscando protocolos actualizados en internet sin encontrar nada sólido',
  'Tu competencia parece más organizada y cobra más, aunque sepa lo mismo que vos',
]

export type Tomo = {
  number: string
  title: string
  emoji: string
  description: string
  includes: string[]
}

export const tomos: Tomo[] = [
  {
    number: 'Tomo 1',
    emoji: '📘',
    title: 'Columna & Postura',
    description:
      'Cervicalgia, dorsalgias laborales, lumbalgia mecánica y reeducación postural. Protocolos listos para dar al paciente, con semáforo del dolor incluido.',
    includes: [
      'Ejercicios paso a paso',
      'Checklists clínicos',
      'Progresiones por fase',
      'Textos de WhatsApp listos',
      'Tablas de dosificación',
      '100% adaptado a Argentina',
    ],
  },
  {
    number: 'Tomo 2',
    emoji: '💪',
    title: 'Miembro Superior',
    description:
      'Hombro, codo, muñeca y mano. Wall slides, PNF, excéntricos para epicondilalgias, BFR, mirror therapy y protocolos postquirúrgicos completos.',
    includes: [
      'Ejercicios paso a paso',
      'Mapas de selección rápida',
      'Protocolos postquirúrgicos',
      'Textos de WhatsApp listos',
      'Tablas de dosificación',
      'Ideas nuevas para implementar hoy',
    ],
  },
  {
    number: 'Tomo 3',
    emoji: '🦵',
    title: 'Miembro Inferior & Retorno al Deporte',
    description:
      'Cadera, rodilla, tobillo y retorno deportivo. Nordic curl, pliometría, perturbation training, criterios de alta y tests funcionales completos.',
    includes: [
      'Ejercicios paso a paso',
      'Tests funcionales',
      'Criterios de alta',
      'Textos de WhatsApp listos',
      'Progresiones nuevas',
      '100% adaptado a Argentina',
    ],
  },
]

export type Bono = {
  number: string
  title: string
  description: string
  price: string
}

export const bonos: Bono[] = [
  {
    number: '01',
    title: 'Kit SOS Paciente Nuevo',
    description:
      'Plan de acción para el primer día con un paciente que no sabe qué tiene ni qué esperar.',
    price: '$9.000',
  },
  {
    number: '02',
    title: 'Mapa Visual de Ejercicios por Patología',
    description:
      'Carteles y tablas imprimibles para colgar en el consultorio y entregar al paciente.',
    price: '$8.000',
  },
  {
    number: '03',
    title: 'Guía Express de Comunicación Clínica',
    description:
      'Cómo explicar diagnósticos difíciles en palabras simples para aumentar la adherencia.',
    price: '$8.000',
  },
  {
    number: '04',
    title: 'Planner de Agenda y Protocolos Semanales',
    description:
      'Organizá tu semana de consultas en 20 minutos con los protocolos ya listos.',
    price: '$9.000',
  },
  {
    number: '05',
    title: 'Scripts para WhatsApp, Médicos y Pacientes',
    description:
      'Mensajes listos para copiar y pegar para seguimiento, derivaciones y cierre de tratamiento.',
    price: '$8.000',
  },
  {
    number: '06',
    title: 'Sistema PVI: Prescripción Visual Instantánea',
    description:
      'Guía completa para entregar tus protocolos digitales y posicionarte como el kine de élite de tu zona.',
    price: '$8.000',
  },
]

export type Pack = {
  id: string
  emoji: string
  name: string
  tagline: string
  subtitle: string
  features: string[]
  priceBefore: string
  price: string
  cta: string
  url: string
  featured: boolean
}

export const packs: Pack[] = [
  {
    id: 'esencial',
    emoji: '📘',
    name: 'Mega Pack Esencial',
    tagline: '',
    subtitle: '3 Tomos + 6 Bonos',
    features: [
      'Tomo 1 — Columna & Postura',
      'Tomo 2 — Miembro Superior',
      'Tomo 3 — Miembro Inferior & Deporte',
      'Los 6 bonos completos',
      'Acceso inmediato por PDF',
    ],
    priceBefore: '$60.000',
    price: '$19.990',
    cta: 'Quiero mi Mega Pack',
    url: CHECKOUT_ESENCIAL,
    featured: false,
  },
  {
    id: 'premium',
    emoji: '⭐',
    name: 'Pack Premium',
    tagline: 'Más completo',
    subtitle: '3 Tomos + 6 Bonos + Método Kine-Elite',
    features: [
      'Todo lo del Mega Pack Esencial',
      'Método Kine-Elite completo',
      'Sistema de comunicación de alto valor',
      'Scripts de venta ética y adherencia',
      'Plan de negocio para consultorio independiente',
    ],
    priceBefore: '$85.000',
    price: '$27.990',
    cta: 'Quiero el Pack Premium',
    url: CHECKOUT_PREMIUM,
    featured: true,
  },
]

export type Testimonial = {
  quote: string
  name: string
  city: string
}

export const heroTestimonials: Testimonial[] = [
  {
    quote: 'Organicé los protocolos de toda la semana en una tarde. Nunca más improvisar.',
    name: 'Martina G.',
    city: 'Córdoba',
  },
  {
    quote: 'Mis pacientes por fin hacen los ejercicios en casa. La adherencia mejoró un 80%.',
    name: 'Lucas P.',
    city: 'Rosario',
  },
  {
    quote: 'Bajé el tiempo de consulta un 40% porque ya tengo todo preparado para entregar.',
    name: 'Romina M.',
    city: 'Buenos Aires',
  },
]

export const resultTestimonials: Testimonial[] = [
  {
    quote:
      'El mapa visual de ejercicios fue un antes y un después. Mis pacientes llegan a la segunda sesión habiendo hecho todo bien.',
    name: 'Cecilia R.',
    city: 'Mendoza',
  },
  {
    quote:
      'Los scripts para WhatsApp los usé al otro día. El paciente me agradeció la claridad y renovó el tratamiento completo.',
    name: 'Pablo A.',
    city: 'Neuquén',
  },
  {
    quote:
      'Ahora tengo los protocolos de toda la semana listos en 10 minutos. Antes tardaba una hora.',
    name: 'Valeria M.',
    city: 'Tucumán',
  },
]

export const faqs = [
  {
    question: '¿Sirve si recién empecé a ejercer?',
    answer:
      'Sí. El Bono 1 (Kit SOS Paciente Nuevo) está diseñado exactamente para ese momento. Además los tomos explican el razonamiento detrás de cada ejercicio, no solo el "cómo".',
  },
  {
    question: '¿Los protocolos son actualizados?',
    answer:
      'Sí. Incluyen técnicas de última generación: BFR, perturbation training, graded motor imagery, nordic curl progresivo, y mucho más.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Al confirmar el pago recibís un email con el acceso a todos los PDFs. En menos de 5 minutos ya los tenés en tu celular o computadora.',
  },
  {
    question: '¿Es solo teoría o tiene casos prácticos?',
    answer:
      'Mayormente ejercicios. Cada protocolo tiene nombre del ejercicio, dosificación, cómo explicárselo al paciente y progresión por fases.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días de garantía total. Si no te convence, escribís a soportenuevonivel@gmail.com y te devolvemos el 100% sin preguntas.',
  },
]
